/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './default-route-page-meta.resolver';
export * from './page-link.service';
export * from './route-page-meta.model';
export {
  RoutingPageMetaResolver,
  RoutingResolveBreadcrumbsOptions,
} from './routing-page-meta.resolver';
